import { render, staticRenderFns } from "./QuestionPreviewCard.vue?vue&type=template&id=5efa1e06&scoped=true"
import script from "./QuestionPreviewCard.vue?vue&type=script&lang=js"
export * from "./QuestionPreviewCard.vue?vue&type=script&lang=js"
import style0 from "./QuestionPreviewCard.vue?vue&type=style&index=0&id=5efa1e06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efa1e06",
  null
  
)

export default component.exports